function initShareButton(button, options = {}) {
   if (!button) {
     return;
   }
 
   const originalText = button.querySelector('span')?.textContent;
   const originalIcon = button.querySelector('i')?.className || 'fa-solid fa-share-alt';
   const feedbackText = button.getAttribute('data-share-feedback-text') || 'Link kopiert!';
   
   button.addEventListener('click', async function(event) {
     event.preventDefault();
 
     const url = options.url || window.location.href;
 
     function isMobileDevice() {
       return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
     }
 
     if (navigator.share && isMobileDevice()) {
       try {
         await navigator.share({
           title: document.title,
           url: url
         });
       } catch (err) {
         console.log('Teilen abgebrochen oder Fehler:', err);
       }
     } else {
       try {
         await navigator.clipboard.writeText(url);
 
         const span = button.querySelector('span');
         const icon = button.querySelector('i');
 
         // Text und Icon ändern
         if (span) {
           span.textContent = feedbackText;
         }
         if (icon) {
           icon.className = 'fa-solid fa-check'; // Erfolgs-Icon
         }
 
         // Farbe und Shake-Effekt anwenden
         button.classList.add('btn-success', 'share-shake');
 
         // Shake-Animation nach 0.5s entfernen
         setTimeout(() => {
           button.classList.remove('share-shake');
         }, 500); // Dauer exakt wie Animation
 
         // Nach 3 Sekunden alles zurücksetzen
         setTimeout(() => {
           if (span) {
             span.textContent = originalText;
           }
           if (icon) {
             icon.className = originalIcon;
           }
           button.classList.remove('btn-success');
         }, 3000);
 
       } catch (err) {
         console.error('Fehler beim Kopieren:', err);
         alert('Fehler beim Kopieren der URL.');
       }
     }
   });
 }
 
 // Auto-Init für alle Buttons mit data-share-button
 document.addEventListener('DOMContentLoaded', function() {
   const shareButtons = document.querySelectorAll('[data-share-button]');
   shareButtons.forEach(button => {
     const url = button.getAttribute('data-share-url');
     initShareButton(button, { url: url });
   });
 });
 
